import { EChannelType, TChannel } from 'types';

enum EFakeChannelType {
  ADMIN = 'fake-admin',
  SYSTEM = 'fake-system',
  YARIKANO = 'fake-yarikano',
}

type FakeChannelItem = {
  type: EFakeChannelType;
  id: string;
};

type BuildChannelListParams = {
  channelsView: TChannel[];
  isAuthenticated: boolean;
  /** Hide Yarikano row while search is active (search results should not mix promo rows). */
  showYarikano?: boolean;
};

const isManagementChannel = (channel: TChannel): boolean =>
  channel.type === EChannelType.MALE_MANAGEMENT;

const isSystemManagementChannel = (channel: TChannel): boolean =>
  channel.type === EChannelType.MALE_SYSTEM_MANAGEMENT;

/** Pin admin → system → Yarikano at the top, then append remaining channels. */
const buildChannelListWithPinnedRows = ({
  channelsView,
  isAuthenticated,
  showYarikano = true,
}: BuildChannelListParams): Array<TChannel | FakeChannelItem> => {
  const pinnedTop: Array<TChannel | FakeChannelItem> = [];

  const adminChannel = channelsView.find(isManagementChannel);
  const systemChannel = channelsView.find(isSystemManagementChannel);

  const showAdminChannel = !isAuthenticated && !adminChannel;
  const showSystemChannel = !isAuthenticated && !systemChannel;

  if (adminChannel) {
    pinnedTop.push(adminChannel);
  } else if (showAdminChannel) {
    pinnedTop.push({ type: EFakeChannelType.ADMIN, id: EFakeChannelType.ADMIN });
  }

  if (systemChannel) {
    pinnedTop.push(systemChannel);
  } else if (showSystemChannel) {
    pinnedTop.push({
      type: EFakeChannelType.SYSTEM,
      id: EFakeChannelType.SYSTEM,
    });
  }

  if (showYarikano) {
    pinnedTop.push({
      type: EFakeChannelType.YARIKANO,
      id: EFakeChannelType.YARIKANO,
    });
  }

  const rest = channelsView.filter(
    (channel) => channel !== adminChannel && channel !== systemChannel,
  );

  return [...pinnedTop, ...rest];
};

export {
  EFakeChannelType,
  buildChannelListWithPinnedRows,
  type FakeChannelItem,
  type BuildChannelListParams,
};
